import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_LAST_SUBSCRIPTIONS,
  REMOVE_LAST_SUBSCRIPTIONS,
  RECEIVE_LAST_VALUES,
  SET_VARIABLES_LAST_POLLING,
} from './actions';

const initialState = {
  variablesLastPolling: {},
  lastSubscriptions: {},
  lastData: {},
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_LAST_SUBSCRIPTIONS: {
      const { variableIds, panelId } = action;
      return {
        ...state,
        lastSubscriptions: {
          ...state.lastSubscriptions,
          ...variableIds.reduce((acc, variableId) => {
            acc[variableId] = {
              ...state.lastSubscriptions[variableId],
              [panelId]: true,
            };
            return acc;
          }, {}),
        },
      };
    }
    case REMOVE_LAST_SUBSCRIPTIONS: {
      const { variableIds, panelId } = action;
      return {
        ...state,
        lastSubscriptions: {
          ...state.lastSubscriptions,
          ...variableIds.reduce((acc, variableId) => {
            const updated = { ...state.lastSubscriptions[variableId] };
            delete updated[panelId];
            acc[variableId] = updated;
            return acc;
          }, {}),
        },
      };
    }
    case SET_VARIABLES_LAST_POLLING: {
      return {
        ...state,
        variablesLastPolling: {
          ...state.variablesPolling,
          ...action.data,
        },
      };
    }
    case RECEIVE_LAST_VALUES: {
      const newLastData = { ...state.lastData };

      for (const value of action.values) {
        newLastData[value.variable] = value.value;
      }

      return { ...state, lastData: newLastData };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
